export default __webpack_public_path__ + "static/media/thirdPlace.7f685391.png";